import { jsx as _jsx } from "react/jsx-runtime";
const IconNoResults = () => {
    return (_jsx("img", { src: "https://cdn.shopify.com/s/files/1/0816/6431/1592/files/Img-LocalidadSinHorario_1.svg?v=1723240573", alt: "no results" }));
};
export default IconNoResults;
